import axios from 'axios';
import { getAccessToken } from '../../utils/tokenUtils';

class ActionProvider {
  constructor(createChatBotMessage, setStateFunc, createClientMessage) {
    this.createChatBotMessage = createChatBotMessage;
    this.setState = setStateFunc;
    this.createClientMessage = createClientMessage;
  }

  handleUserMessage = async (message) => {
    // Show loading message
    const loadingMessage = this.createChatBotMessage('Thinking...');
    this.addMessageToState(loadingMessage);

    try {
      // Get courseCode from window (set by ChatbotWidget)
      const courseCode = window.__CHATBOT_COURSE_CODE__ || 'course_1';

      // Make API call to the learning bot
      const response = await axios.post(
        process.env.REACT_APP_CHATBOT_API_URL,
        {
          question: message,
          key: courseCode.replace(/\s/g, '')
        },
        {
          headers: {
            'Content-Type': 'application/json',
            ...(getAccessToken() && { Authorization: `Bearer ${getAccessToken()}` })
          }
        }
      );

      // Remove loading message and add actual response
      const botMessage = this.createChatBotMessage(
        response.data.answer || 'Empty Response'
      );

      this.updateLastMessage(botMessage);

    } catch (error) {
      console.error('Chatbot API Error:', error);

      // Show error message
      const errorMessage = this.createChatBotMessage(
        'Sorry, I encountered an error. Please try again later.'
      );

      this.updateLastMessage(errorMessage);
    }
  };

  addMessageToState = (message) => {
    this.setState((prevState) => ({
      ...prevState,
      messages: [...prevState.messages, message],
    }));
  };

  updateLastMessage = (newMessage) => {
    this.setState((prevState) => {
      const messages = [...prevState.messages];
      messages[messages.length - 1] = newMessage;
      return {
        ...prevState,
        messages,
      };
    });
  };
}

export default ActionProvider;
